/* eslint-disable func-style */
import React, { useState, useMemo } from 'react';
import { useMonitoringContext } from './MonitorContext.jsx';
import moment from 'moment-timezone';
// eslint-disable-next-line import/no-named-as-default
import styled from 'styled-components';
import useInterval from '../hooks/useInterval.jsx';

const INTERVAL_DELAY = 60000;

const Footer = styled.p`
  text-align: center;
`;
const ExpiredFooter = styled(Footer)`
  color: #912d2b;
`;

function getFormattedDate(date) {
  return (
    date && moment(date).tz(moment.tz.guess()).format('MMMM Do YYYY, h:mm a z')
  );
}

export default function FooterHandler() {
  const {
    state: { isExpired, isMonitoring },
  } = useMonitoringContext();

  if (isExpired) {
    return (
      <ExpiredFooter>
        This page has expired, please contact support for further assistance.
      </ExpiredFooter>
    );
  }

  if (isMonitoring) {
    return <MonitoringFooter />;
  }

  return null;
}

function MonitoringFooter() {
  const {
    state: { expiresAt, isMonitoring },
  } = useMonitoringContext();
  const [expiresIn, setExpiresIn] = useState(() => moment(expiresAt).fromNow());
  const formattedExpiresAt = useMemo(
    () => getFormattedDate(expiresAt),
    [expiresAt],
  );

  useInterval(
    () => {
      setExpiresIn(moment(expiresAt).fromNow());
    },
    isMonitoring ? INTERVAL_DELAY : null,
  );

  return (
    <Footer>
      This page will expire {expiresIn} at {formattedExpiresAt}.
    </Footer>
  );
}
